module.exports = __webpack_public_path__ + "img/R@2x.8761286.webp";